<template>
    <div class="rubric-survey-peer-create apprentice-simple-card remove-bottom-card-margin">
        <div class="component-title">
            <h5 class="title">
                {{
                    $tc(
                        'rubrics.choose_x_students_who_will_also_complete_your_rubrics',
                        assignmentRubricUserIn.assignment_rubric.peer_amount,
                    )
                }}
            </h5>
        </div>

        <div class="select-container">
            <b-form-group
                class="peer-select"
                :label="$t('rubrics.select_peer')"
                label-for="peer-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="peer-select"
                    v-model="selectedPeer"
                    text-field="user.full_name"
                    value-field="id"
                    :options="availableUsers"></b-form-select>
            </b-form-group>
            <div class="peer-select-add-btn">
                <b-button
                    class="btn-add"
                    variant="primary"
                    @click="addPeer()"
                    :disabled="!selectedPeer">
                    {{ $t('common.add') }}
                </b-button>
            </div>
        </div>

        <div
            class="peer-error-container"
            v-if="error">
            <b-alert
                show
                variant="warning"
                >{{ $t('rubrics.you_already_added_the_maximum_number_of_peers') }}
            </b-alert>
        </div>

        <div
            class="selected-peer-container"
            v-if="selectedPeers.length">
            <b-list-group
                v-for="assignmentRubricUser of selectedUsers"
                :key="assignmentRubricUser.id">
                <b-list-group-item class="selected-peer-list-group-item">
                    <span class="selected-peer-list-group-item-title">{{ assignmentRubricUser.user.full_name }}</span>
                    <b-button
                        class="btn-remove selected-peer-list-group-item-btn"
                        variant="danger"
                        @click="removeSelectedPeer(assignmentRubricUser.id)"></b-button>
                </b-list-group-item>
            </b-list-group>
        </div>

        <b-button
            class="peer-save-btn"
            v-if="selectedPeers.length === assignmentRubricUserIn.assignment_rubric.peer_amount"
            variant="primary"
            @click="savePeers()"
            >{{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-peer-create-component',
    props: {
        assignmentRubricUserIn: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            selectedPeer: null,
            selectedPeers: [],
            error: false,
        };
    },
    computed: {
        availableUsers() {
            let users = this.assignmentRubricUserIn.assignment_rubric.assignment_rubric_users.filter(
                (assignment_rubric_user) => {
                    return (
                        assignment_rubric_user.id !== this.assignmentRubricUserIn.id &&
                        assignment_rubric_user.user_id !== this.$authUser.id &&
                        !this.selectedPeers.includes(assignment_rubric_user.id)
                    );
                },
            );

            users.unshift({ id: null, user: { full_name: this.$t('rubrics.select_peer') } });

            return users;
        },
        selectedUsers() {
            return this.assignmentRubricUserIn.assignment_rubric.assignment_rubric_users.filter(
                (assignment_rubric_user) => this.selectedPeers.includes(assignment_rubric_user.id),
            );
        },
    },
    methods: {
        addPeer() {
            if (!this.selectedPeer) {
                return;
            }

            if (this.selectedPeers.length === this.assignmentRubricUserIn.assignment_rubric.peer_amount) {
                this.error = true;
                return;
            }

            this.selectedPeers.push(this.selectedPeer);
            this.selectedPeer = null;
        },
        removeSelectedPeer(id_to_remove) {
            this.error = false;
            this.selectedPeers = this.selectedPeers.filter((id) => id !== id_to_remove);
        },
        savePeers() {
            const data = {
                assignment_rubric_user_id: this.assignmentRubricUserIn.id,
                ids: this.selectedPeers,
            };

            this.axios.post(this.routes.assignmentRubricUserPeerStudentStore(), data).then(
                (response) => {
                    window.location.href =
                        this.routes.baseUrl() +
                        this.routes.rubricFormEdit(this.assignmentRubricUserIn.rubric_forms[0].id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.peer-error-container {
    margin-top: 15px;
}

.selected-peer-container {
    margin-top: 30px;
    width: 400px;
}

.peer-save-btn {
    margin-top: 30px;
}

.selected-peer-list-group-item {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}

.select-container {
    display: flex;
    align-items: center;
    flex-direction: row;

    .peer-select {
        margin-bottom: 0;
    }

    select {
        margin-bottom: 0;
    }

    .peer-select-add-btn {
        align-self: flex-end;
        margin-left: 15px;
    }
}
</style>
